"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactQuery = require("react-query");
var _reactI18next = require("react-i18next");
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _allergens = require("../../services/allergens");
var _axios = _interopRequireDefault(require("axios"));
var _clsx = _interopRequireDefault(require("clsx"));
var _elementHeadline = _interopRequireDefault(require("../element-headline"));
var _filterButtonGroup = _interopRequireDefault(require("../filter-button-group"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  text: {
    marginTop: theme.spacing(1.5)
  },
  item: {
    alignItems: "center",
    background: theme.palette.background.light,
    border: "1px solid ".concat(theme.palette.background.light),
    color: theme.palette.foreground.contact.label,
    cursor: "pointer",
    display: "flex",
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1.5, 2),
    transitionProperty: "all",
    transitionDuration: theme.transitions.duration.standard,
    transitionTimingFunction: theme.transitions.easing.sharp,
    "&:hover": {
      background: theme.palette.common.white,
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
      "& $icon": {
        background: theme.palette.primary.main,
        color: theme.palette.common.white
      }
    }
  },
  itemSelected: {
    background: theme.palette.common.white,
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
    "& $icon": {
      background: theme.palette.primary.main,
      color: theme.palette.common.white
    },
    "& $title": {
      "&::before": {
        opacity: 1
      }
    },
    "& $excludeLabel": {
      opacity: 1
    }
  },
  icon: {
    alignItems: "center",
    backgroundColor: theme.palette.background.allergenIcon,
    borderRadius: "50%",
    color: theme.palette.common.white,
    cursor: "pointer",
    display: "flex",
    height: theme.spacing(3.5),
    justifyContent: "center",
    marginRight: theme.spacing(1),
    transitionProperty: "all",
    transitionDuration: theme.transitions.duration.standard,
    transitionTimingFunction: theme.transitions.easing.sharp,
    width: theme.spacing(3.5)
  },
  title: {
    flex: 1,
    marginRight: theme.spacing(1.5),
    position: "relative",
    "&::before": {
      background: theme.palette.primary.main,
      content: "''",
      height: 1,
      left: 0,
      opacity: 0,
      position: "absolute",
      right: 0,
      top: "50%",
      transitionProperty: "opacity",
      transitionDuration: theme.transitions.duration.standard,
      transitionTimingFunction: theme.transitions.easing.sharp
    }
  },
  label: {
    marginLeft: "auto",
    textTransform: "uppercase"
  },
  excludeLabel: {
    opacity: 0,
    transitionProperty: "opacity",
    transitionDuration: theme.transitions.duration.standard,
    transitionTimingFunction: theme.transitions.easing.sharp,
    ...theme.customTypography.allergensExcludeLabel
  },
  inputLabel: {
    marginBottom: theme.spacing(-2)
  }
}));
const AllergenFilter = _ref => {
  let {
    data,
    onFilter
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  const handleClick = value => {
    let index = data.findIndex(allergen => allergen === value);
    if (index === -1) {
      onFilter({
        allergens: [...data, value]
      });
      return;
    }
    onFilter({
      allergens: data.filter(allergen => allergen !== value)
    });
  };
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 4
  }, _allergens.allergens.map(_ref2 => {
    let {
      id,
      title,
      value
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      className: (0, _clsx.default)({
        [css.item]: true,
        [css.itemSelected]: data.includes(value)
      }),
      key: id,
      container: true,
      onClick: () => handleClick(value)
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: css.icon
    }, value)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      className: css.title,
      item: true
    }, t(title)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      className: css.label,
      item: true
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: css.excludeLabel
    }, t("site.ui.labels.exclude"))));
  }));
};
const CategoryFilter = props => {
  var _items;
  const {
    categories,
    id,
    onChange
  } = props;
  const {
    t,
    i18n
  } = (0, _reactI18next.useTranslation)();
  const {
    REACT_APP_PATH
  } = process.env;
  const css = useStyles();
  const url = "".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/ListMenuMealFilter.api?lang=").concat(i18n.language, "&menuID=").concat(id);
  const {
    data,
    status
  } = (0, _reactQuery.useQuery)(["list-menu-meal-filter", i18n.language], () => _axios.default.get(url));
  let items = [];
  if (status === "success") {
    var _data$data;
    items = data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 || (_data$data = _data$data.groups) === null || _data$data === void 0 ? void 0 : _data$data.items;
  }
  const handleChange = event => {
    let index = categories.findIndex(item => item === parseInt(event.target.value));
    if (index === -1) {
      onChange({
        groups: [...categories, parseInt(event.target.value)]
      });
      return;
    }
    onChange({
      groups: categories.filter(item => item !== parseInt(event.target.value))
    });
  };
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 4
  }, /*#__PURE__*/_react.default.createElement(_elementHeadline.default, {
    title: t("site.ui.headlines.category"),
    component: "h2"
  }), /*#__PURE__*/_react.default.createElement(_core.FormGroup, null, (_items = items) === null || _items === void 0 ? void 0 : _items.map(item => {
    const {
      id,
      title
    } = item;
    return /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
      key: id,
      className: css.inputLabel,
      control: /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
        checked: categories.includes(id),
        onChange: handleChange,
        value: id
      }),
      label: /*#__PURE__*/_react.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: title
        }
      })
    });
  })));
};
const MenuFilter = _ref3 => {
  var _filter$groups;
  let {
    data,
    id,
    onFilter,
    onFilterOpen
  } = _ref3;
  const [filter, setFilter] = (0, _react.useState)(data);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  const handleConfirm = () => {
    onFilter(filter);
    onFilterOpen(false);
  };
  const handleFilter = values => {
    setFilter({
      ...filter,
      ...values
    });
  };
  const handleReset = () => {
    onFilter({
      allergens: [],
      groups: []
    });
    onFilterOpen(false);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(CategoryFilter, {
    categories: (_filter$groups = filter === null || filter === void 0 ? void 0 : filter.groups) !== null && _filter$groups !== void 0 ? _filter$groups : [],
    id: id,
    onChange: handleFilter
  }), /*#__PURE__*/_react.default.createElement(_elementHeadline.default, {
    title: t("site.ui.headlines.allergenFilter")
  }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.text,
    component: "p"
  }, t("site.ui.descriptions.allergen")), /*#__PURE__*/_react.default.createElement(AllergenFilter, {
    data: filter === null || filter === void 0 ? void 0 : filter.allergens,
    onFilter: handleFilter
  }), /*#__PURE__*/_react.default.createElement(_filterButtonGroup.default, {
    labelConfirm: t("site.ui.buttons.searchMeals"),
    labelReset: t("site.ui.buttons.reset"),
    onConfirm: handleConfirm,
    onReset: handleReset
  }));
};
var _default = exports.default = MenuFilter;